import { AlertService } from './../../shared/services/alert.service';
import { UrlService } from './../../shared/services/url.service';
import { GlobalService } from '../../shared/global.service';
import { TranslateService } from '@ngx-translate/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, Input, Output, ɵConsole, ElementRef, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { Accesibilidad } from 'src/app/models/acceibilidad.model';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';


@Component({
  selector: 'app-menu-principal',
  templateUrl: './menu-principal.component.html',
  styleUrls: ['./menu-principal.component.scss']
})

export class MenuPrincipalComponent implements OnInit {

  @Input() public estadoMenu: any;
  @Output() public fontValue = new EventEmitter();
  @Output() theme = new EventEmitter();
  @Output() accionMenu = new EventEmitter();
  @HostBinding('class') componentCssClass;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  public opened = true;
  public menu: any[];
  public accesibilidad = false;
  public checked = false;
  public checkedgif = true;
  public gif;
  public tamanoletra = 100;
  public style;
  public modificacionmenu;
  public modificacioncontenido;
  public aumentomenu = 18;
  public aumentocontenido = 18;
  public aumentoright = 0;
  public tamanioLetraApp = 100;
  public rolUsuario: string;
  public checkBlack: boolean;
  public checkPink: boolean;
  public checkGray: boolean;
  public checkTeclado: boolean;
  public timerGuardadoAccesibilidad: any;
  public accesibilidadUsuario: Accesibilidad = new Accesibilidad(); 
  public contrasteVistible: boolean = false;



  constructor(
      public breakpointObserver: BreakpointObserver
    , public overlayContainer: OverlayContainer
    , public router: Router
    , private translate: TranslateService
    , private global: GlobalService
    , private urlService: UrlService
    , private alertService: AlertService) {

  }

  ngOnInit() {
   //---accesibilidad
    this.cargarValoresIniciales();
    this.menu = [];
    const theme = this.accesibilidadUsuario.contrasteTema ? this.accesibilidadUsuario.contrasteTema: sessionStorage.getItem('theme');
    const lang = sessionStorage.getItem('idioma');
    this.translate.setDefaultLang(lang);
    this.habilitarModo();
    if (theme === 'yeti') {
      this.checked = false;
      this.checkBlack = false;
      this.checkGray = false;
      this.checkPink = false;
    } else {
      this.validarTema(theme);
    }
    this.theme.emit({  theme });
    this.opened = true;
    this.validarRol();
  }

  habilitarModo() {
    if (this.checkTeclado) {
        $('.modo-teclado-inactivo').addClass('modo-teclado');
    } else {
        $('.modo-teclado-inactivo').removeClass('modo-teclado');
    }
}

  validarRol() {
    const usuario = sessionStorage.getItem('Usuario');
    if (usuario) {
      this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION_SIA3);
      if (!this.rolUsuario) {
        this.router.navigate(['/rol']);
      } else {
        this.getPermisosRol();
      }
    } else {
      setTimeout(() => {
        this.validarRol();
      }, 500);
    }
  }


  // 02/07/2019
  // Valida el tema y activa o inactiva los checks
  validarTema(theme) {
    switch (theme) {
      case 'dark-white':
        this.checkBlack = true;
        this.checkGray = false;
        this.checkPink = false;
        break;
      case 'rosa-fucsia':
        this.checkPink = true;
        this.checkGray = false;
        this.checkBlack = false;
        break;
      case 'gris-blanco':
        this.checkGray = true;
        this.checkBlack = false;
        this.checkPink = false;
        break;
    }

    return theme;
  }

  getPermisosRol() {
    const usuario = JSON.parse(sessionStorage.getItem('Usuario'));
    if (usuario && usuario.permisos) {
      // tslint:disable-next-line: triple-equals
      this.menu = usuario.permisos.filter(opcion => opcion.nombreRolAsociado == this.rolUsuario);
      this.menu.forEach((element, index) => {
        if (element.hijosOpcion) {
          // tslint:disable: triple-equals
          element.hijosOpcion = element.hijosOpcion.filter(hijo => hijo.nombreRolAsociado == this.rolUsuario);
          element.hijosOpcion.forEach(hijo => {
            if (hijo.nombreObjeto != '/main') {
              //Se realiza validacion y ajustes de menus, que utilizan el mismo componente, dado que SIA3 no permite 
              //definir mas de un menu con el mismo nombreObjeto
              if( this.rolUsuario === VariablesZonaCompartida.ROL_TALENTO_HUMANO){
                  if( hijo.nombreObjeto === VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL ){
                    hijo.descripcion = 'Administrar Personal Planta';
                  }
                  if( hijo.nombreObjeto === "/registro-carga-inventario" ){
                    hijo.descripcion = '';
                  }
              }else
                if( hijo.nombreObjeto === VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL_TERCE ){
                  hijo.nombreObjeto = VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL;
                }
                  
              hijo.nombreObjeto = '/main' + hijo.nombreObjeto;
            }
          });
        }
      });
      this.setTamanoApp();
    }
  }

  private setTamanoApp() {
    const menuContainerWidth = $('.contenedorMenu').css('width');
    const menuContainerHeight = $('.menuContainer').css('height');
    const marginMenuFooter = $('.menuFooter').css('margin-bottom');
    sessionStorage.setItem('anchoMenu', menuContainerWidth);
    sessionStorage.setItem('altoMenu', menuContainerHeight);
    sessionStorage.setItem('menuFooterBottomPage', marginMenuFooter);
  }

  public setAccesibilidad(accion: boolean) {
      this.contrasteVistible = false;
      this.accesibilidad = accion;
  }

  public setClassActiveLi(event) {
    $('.menuClass').removeClass('selected');
    $('#' + event.currentTarget.parentElement.id).addClass('selected');
  }

  public setClassSubMenu(event) {
    //Se realiza esta validacion para determinar por que opcion se llega a la funcionalidad de cargue masivo.
    //Dado que en SIA3 No es posible que mas de una opcion apunte al mismo componente, se valida por la descripcion
    
    if( event.currentTarget.text.toUpperCase().includes("TERCERIZAD") ){
      sessionStorage.setItem(ConstantesService.OPC_SELECT, VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL_TERCE );
    }else{
      sessionStorage.setItem(ConstantesService.OPC_SELECT,event.currentTarget.id);
    }
    $('.submenu').removeClass('selected');
    $('#' + event.currentTarget.parentElement.id).addClass('selected');
  }

  public navegarAruta(routeValue) {
    this.router.navigate([routeValue]);
  }


  // 02/07/2019
  // Método para setear el tema de la aplicación

  public setTheme(temaSeleccionado?: any, event?) {
    let tema;
    if (event && event.target.checked) {
      tema = this.validarTema(temaSeleccionado);
    } else {
      tema = 'yeti';
    }
    this.theme.emit({ theme: tema });
  }



  // 02/07/2019
  // método para restablecer ajustes predeterminados

  public restablecerAjustes(theme?: any) {
    this.setTheme(theme);
    this.checked = false;
    this.checkBlack = false;
    this.checkGray = false;
    this.checkPink = false;
    this.tamanioLetraApp = 100;
    this.checkedgif = false;
    this.checkTeclado = false;
    this.habilitarModo();
    this.setTamanoLetra('restablecer');
    this.modificarParametros();
  }

  validarTecla(event, route?) {

    const list = document.getElementById('listaMenu');
    const first = list.firstElementChild;
    const last = list.lastElementChild;
    switch (event.keyCode) {
      case 38: // Codigo Ascci Tecla Arriba
        if (document.activeElement != first) {
          const previousSibling: any = document.activeElement.previousSibling;
          document.getElementById(previousSibling.id).focus();
        }
        break;
      case 40: // Codigo Ascci Tecla Abajo
        if (document.activeElement != last) {
          const nextSibling: any = document.activeElement.nextSibling;
          document.getElementById(nextSibling.id).focus();
        }
        break;
      case 13: // codigo Ascci Tecla enter
      case 39: // codigo Ascci Tecla Right
        this.navegarPorTecladoAruta(document.activeElement.id);
        break;
      default:
    }
  }

  navegarPorTecladoAruta(route) {
    let ruta: any;
    switch (route) {
      case 'liFormulario':
        ruta = '/formulario';
        break;
      case 'liContenido':
        ruta = '/contenido';
        break;
      case 'liTabla':
        ruta = '/tabla';
        break;
      default:
        this.router.navigate([route]);
        break;

    }
    this.router.navigate([ruta]);
  }
  // 04/07/2019
  // metodo que altera la pripiedad font size del DOM para umentar el tamaño de letra
  setTamanoLetra(origen?: any) {
    $('body').css('font-size', (this.tamanioLetraApp).toString() + '%');
  }
  changeEstadoMenuMovil() {
    this.accionMenu.emit();
  }
  cathException(error) {
    this.alertService.generateAlertError('NO SE CONSUMIÓ EL TOKEN', 'Error');
  }

  modificarParametros(){
    console.log('cambio parametro'); 
    window.clearTimeout(this.timerGuardadoAccesibilidad);
    this.timerGuardadoAccesibilidad =  setTimeout(() => {
      console.log('Guardado de parametros   ' + new Date());
      this.actualizaSia3();
    }, 5000);
    
  }


  private cargarValoresIniciales(){
    this.accesibilidadUsuario =  JSON.parse(sessionStorage.getItem(ConstantesService.ACCESIBILIDAD_SESSION) );
    console.log(this.accesibilidadUsuario);    
    if(this.accesibilidadUsuario){
      this.checkTeclado = this.accesibilidadUsuario.tecladoVirtualBoolean;
      this.tamanioLetraApp = this.accesibilidadUsuario.tamanioLetraNumber;
      this.checkedgif = this.accesibilidadUsuario.lenguajeSeniasBoolean;
    } else {
      this.checkTeclado = false;
      this.tamanioLetraApp = 100;
      this.checkedgif = false;

    }
    this.setTamanoLetra();   
  }

  public actualizaSia3(){
    //---accesibilidad 
    // return true;
    const serviceProvider = 'PersistirParametrosAccesibilidad';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['user_id', sessionStorage.getItem(ConstantesService.SIA3_SESSSION)]);
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), sessionStorage.getItem('urlBase'));
    // url = 'http://sia3rcert.mineducacion.gov.co/seguridad-apiRest-pub/recursoswebseguridad/accesibilidad/AlmacenarPropiedadesAccUser/almacenarPropAccesibilidad';
    this.global.postSIA3Seguro(url, this.procesarGuardadoAccesibilidad()).subscribe(
      data => {
        console.log('Funciono');
        this.alertService.generateAlertSuccess('Se relizó el guardado de los parametros de accesibilidad de manera correcta', '');

      }, (err: any) => {
        this.alertService.generateAlertSuccess('Ocurrio un error en el  guardado de los parametros de accesibilidad', '');

        console.log('Fallo');

      }
    );

  }


  /**
   * Método encargado de procesar los parametro de accesibilidad
   */
  private procesarGuardadoAccesibilidad(): Accesibilidad {    
    let accesibilidadPersistencia: Accesibilidad = new Accesibilidad();
    accesibilidadPersistencia.tamanioLetra =  this.tamanioLetraApp.toString();
    accesibilidadPersistencia.lenguajeSenias = this.checkedgif  ? 'true' : 'false';
    accesibilidadPersistencia.tecladoVirtual = this.checkTeclado ? 'true' : 'false';
    accesibilidadPersistencia.contrasteDefault = this.temaNumerico();
    accesibilidadPersistencia.tiempoMensajes = this.accesibilidadUsuario.tiempoMensajes;
    accesibilidadPersistencia.tiempoReversibilidad = this.accesibilidadUsuario.tiempoReversibilidad;
    return accesibilidadPersistencia;
    
  }

  temaNumerico(): string {
    let temaContraste = '1';
    if(this.checkBlack) {
      temaContraste = '2';
    }

    if(this.checkPink) {
      temaContraste = '3';
    }

    if(this.checkGray) {
      temaContraste = '4';
    }
    return temaContraste;
  }

}




 